export default __webpack_public_path__ + "static/media/comandas.9cf171c7.svg";